const DEFAULT_RETURN_TO = "/dashboard";

export function safeReturnTo(value: string | null | undefined): string {
    if (!value || !value.startsWith("/") || value.startsWith("//")) return DEFAULT_RETURN_TO;
    try {
        const parsed = new URL(value, "https://product-studio.invalid");
        if (parsed.origin !== "https://product-studio.invalid") return DEFAULT_RETURN_TO;
        if (parsed.pathname !== "/dashboard" && !parsed.pathname.startsWith("/dashboard/")) return DEFAULT_RETURN_TO;
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return DEFAULT_RETURN_TO;
    }
}

export function returnToFromSearch(search: string): string {
    return safeReturnTo(new URLSearchParams(search).get("returnTo"));
}

export function authPath(returnTo: string): string {
    const safe = safeReturnTo(returnTo);
    return safe === DEFAULT_RETURN_TO ? "/auth" : `/auth?returnTo=${encodeURIComponent(safe)}`;
}

export function splashPath(returnTo: string): string {
    const safe = safeReturnTo(returnTo);
    return safe === DEFAULT_RETURN_TO ? "/splash" : `/splash?returnTo=${encodeURIComponent(safe)}`;
}
